import React, { FC } from "react";
import { AdminConfigCategoriesView } from "../../components";

export const AdminConfigCategoriesPage: FC = () => {
  return <AdminConfigCategoriesView />;
};
